import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogoMark } from "./Logo";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-[var(--es-line)]"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link">
          <LogoMark />
        </Link>
        <nav className="flex items-center gap-6 font-ui text-sm">
          <Link
            to="/indices"
            className="es-link-underline text-[var(--es-ink-soft)] hover:text-[var(--es-blue)] hidden sm:inline"
            data-testid="nav-indices-link"
          >
            Indices
          </Link>
          <Link
            to="/quiz"
            className="es-link-underline text-[var(--es-ink-soft)] hover:text-[var(--es-blue)] hidden sm:inline"
            data-testid="nav-quiz-link"
          >
            Take Assessment
          </Link>
          {user && user !== false ? (
            <>
              <Link
                to="/dashboard"
                className="es-link-underline text-[var(--es-ink-soft)] hover:text-[var(--es-blue)]"
                data-testid="nav-dashboard-link"
              >
                Dashboard
              </Link>
              <button
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="text-[var(--es-ink-soft)] hover:text-[var(--es-blue)]"
                data-testid="nav-logout-button"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-[var(--es-ink-soft)] hover:text-[var(--es-blue)]"
                data-testid="nav-login-link"
              >
                Sign in
              </Link>
              <Link
                to="/register"
                className="bg-[var(--es-blue)] text-white px-4 py-2 hover:bg-[var(--es-blue-hover)] transition-colors uppercase tracking-wider text-xs font-semibold"
                data-testid="nav-register-link"
              >
                Begin
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
